import React, {memo, useState} from "react";
import {Link} from "react-scroll"

function NavLink(props: { link: string, text: string, onClick: CallableFunction }) {
    return (
        <li className="nav-item">
            <Link
                to={props.link}
                onClick={() => props.onClick(false)}
                smooth={true}
                spy={true}
                offset={-50}
                duration={500}
                activeClass={"bg-blue-700 text-white"}
                className="nav-link"
            >
                {props.text}
            </Link>
        </li>
    )
}

function Navbar() {

    const [NavListShow, setNavListShow] = useState(false)
    const links = [{
        id: 1,
        link: 'header',
        text: 'Home'
    }, {
        id: 2,
        link: 'about',
        text: 'About'
    }, {
        id: 5,
        link: 'Skills',
        text: 'Skills'
    }, {
        id: 3,
        link: 'PreviousWorks',
        text: 'Previous works'
    }, {
        id: 4,
        link: 'Contact',
        text: 'Contact'
    }
    ];

    return (
        <nav
            className="flex z-10 fixed bg-white top-0 left-0 right-0 justify-between flex-wrap items-center px-5 py-6 shadow">
            <div className="">
                Omar Khaled
            </div>
            <button onClick={() => setNavListShow(!NavListShow)}
                    className="md:hidden rounded-lg border-2 h-7 w-7 grid place-items-center">
                <i className="bi bi-three-dots-vertical"></i>
            </button>
            <div
                className={`md:w-auto w-full md:h-auto default-h-0 ${NavListShow ? 'h-56' : 'h-0'} overflow-hidden transition-all duration-300 ease-in-out `}>
                <ul className="list-none md:flex-row flex-col flex items-center gap-1">

                    {links.map(link => <NavLink onClick={setNavListShow} key={link.id} link={link.link} text={link.text}/>)}

                </ul>
            </div>
        </nav>
    )
}

export default memo(Navbar)